import { Component, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { NewLeadsTableComponent } from './newleads-table.component';

@Component({
  selector: 'newleads-header',
  templateUrl: './newleads-header.component.html',
  styleUrls: ['./newleads-header.component.css'],
  providers: [HubService],
})

export class NewLeadsHeaderComponent implements OnInit{
  rowCount: string;
  uploadFlag: boolean = false;
  addFlag: boolean = false;
  @ViewChild('child', { static: true }) child:  NewLeadsTableComponent;

  headerUIDList: number[] = [];

  new: boolean = false;
  unresolved: boolean = false;
  onhold: boolean = false;
  dead: boolean = false;
  loading: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.new = true;
    this.unresolved = this.dead = this.onhold = false;
  }

  exportLeadsCSV(): void{
      this.child.exportLeadsCSV();
  }

  receiveCount($event: string) {
    this.rowCount = $event
  }

  receiveUIDList($event: any) {
    this.headerUIDList = $event
  }

  getColor(toggle: boolean): any {
    if (toggle == true) {
      return '#c2185b';
    } else {
      return '#DDD';
    }
  }

  displayUpload(): void {
    this.uploadFlag = !this.uploadFlag;
    this.addFlag = false;
  }

  displayAdd(): void {
    this.addFlag = !this.addFlag;
    this.uploadFlag = false;
  }

  receiveUploadFlag($event: any) {
    this.uploadFlag = $event;
    this.child.initalizeFromParent();
  }

  receiveAddFlag($event: any) {
    this.addFlag = $event;
    this.child.initalizeFromParent();
  }

  switchType(type: string): void {
    switch (type) {
        case 'new':
            this.new = true;
            this.unresolved = this.dead = this.onhold = false;
            break;
        case 'unresolved':
            this.unresolved = true;
            this.dead = this.onhold = this.new = false;
            break;
        case 'dead':
            this.dead = true;
            this.onhold = this.new = this.unresolved = false;
            break;
        case 'onhold':
            this.onhold = true;
            this.new = this.unresolved = this.dead = false;
            break;
    }
    this.child.initalizeFromHeader(type);
}
  
}
